import { EventEmitter } from '@angular/core';

export enum NotificationType {
  Success = 'success',
  Error = 'error',
  Alert = 'alert',
  Info = 'info',
  Warn = 'warn',
  Bare = 'bare',
}
export enum NotificationAnimationType {
  Fade = 'fade',
  FromTop = 'fromTop',
  FromRight = 'fromRight',
  FromBottom = 'fromBottom',
  FromLeft = 'fromLeft',
  Scale = 'scale',
  Rotate = 'rotate',
}
export interface Icons {
  alert: string;
  error: string;
  info: string;
  warn: string;
  success: string;
}
export interface NotificationEvent {
  add?: boolean;
  command: string;
  id?: string;
  notification?: Notification;
}
export interface Notification {
  id?: string;
  type: NotificationType;
  icon: string;
  title?: any;
  content?: any;
  override?: any;
  html?: any;
  state?: string;
  createdOn?: Date;
  destroyedOn?: Date;
  animate?: NotificationAnimationType;
  timeOut?: number;
  maxLength?: number;
  pauseOnHover?: boolean;
  clickToClose?: boolean;
  clickIconToClose?: boolean;
  theClass?: string;
  click?: EventEmitter<{}>;
  clickIcon?: EventEmitter<{}>;
  timeoutEnd?: EventEmitter<{}>;
  context?: any;
}

export type VerticalPosition = 'top' | 'bottom' | 'middle';
export type HorizontalPosition = 'right' | 'left' | 'center';
export interface Position extends Array<VerticalPosition | HorizontalPosition> {
  0: VerticalPosition;
  1: HorizontalPosition;
}

export interface Options {
  position?: Position;
  timeOut?: number;
  showProgressBar?: boolean;
  pauseOnHover?: boolean;
  lastOnBottom?: boolean;
  clickToClose?: boolean;
  clickIconToClose?: boolean;
  maxLength?: number;
  maxStack?: number;
  preventDuplicates?: boolean;
  preventLastDuplicates?: boolean | string;
  theClass?: string;
  rtl?: boolean;
  animate?: NotificationAnimationType;
  icons?: Icons;
}
